export default {
    getInstituciones,
    getInstitucion,
    getTipoCuenta
}

function getInstituciones() {
    return instituciones
        .map(([value, text]) => ({ value, text }))
        .sort((a, b) => a.text.localeCompare(b.text, 'es'))
}

function getInstitucion(clave) {
    const found = instituciones.find(([value]) => value == clave)
    return found ? `${found[1]}` : clave
}

function getTipoCuenta(tipo) {
    return { 3: 'Tarjeta de débito', 10: 'Teléfono', 40: 'CLABE' }[tipo] || tipo
}

const instituciones = [
    [2001, 'BANXICO'],
    [37006, 'BANCOMEXT'],
    [37009, 'BANOBRAS'],
    [37019, 'BANJERCITO'],
    [37135, 'NAFIN'],
    [37166, 'BaBien'],
    [37168, 'HIPOTECARIA FED'],
    [40002, 'BANAMEX'],
    [40012, 'BBVA MEXICO'],
    [40014, 'SANTANDER'],
    [40021, 'HSBC'],
    [40030, 'BAJIO'],
    [40036, 'INBURSA'],
    [40042, 'MIFEL'],
    [40044, 'SCOTIABANK'],
    [40058, 'BANREGIO'],
    [40059, 'INVEX'],
    [40060, 'BANSI'],
    [40062, 'AFIRME'],
    [40072, 'BANORTE'],
    [40106, 'BANK OF AMERICA'],
    [40108, 'MUFG'],
    [40110, 'JP MORGAN'],
    [40112, 'BMONEX'],
    [40113, 'VE POR MAS'],
    [40124, 'CITI MEXICO'],
    [40127, 'AZTECA'],
    [40128, 'KAPITAL'],
    [40129, 'BARCLAYS'],
    [40130, 'COMPARTAMOS'],
    [40132, 'MULTIVA BANCO'],
    [40133, 'ACTINVER'],
    [40136, 'INTERCAM BANCO'],
    [40137, 'BANCOPPEL'],
    [40138, 'UALA'],
    [40140, 'CONSUBANCO'],
    [40141, 'VOLKSWAGEN'],
    [40145, 'BBASE'],
    [40147, 'BANKAOOL'],
    [40148, 'PAGATODO'],
    [40150, 'INMOBILIARIO'],
    [40151, 'DONDE'],
    [40152, 'BANCREA'],
    [40154, 'BANCO COVALTO'],
    [40155, 'ICBC'],
    [40156, 'SABADELL'],
    [40157, 'SHINHAN'],
    [40158, 'MIZUHO BANK'],
    [40159, 'BANK OF CHINA'],
    [40160, 'BANCO S3'],
    [40167, 'HEY BANCO'],
    [90600, 'MONEXCB'],
    [90601, 'GBM'],
    [90602, 'MASARI'],
    [90605, 'VALUE'],
    [90616, 'FINAMEX'],
    [90617, 'VALMEX'],
    [90620, 'PROFUTURO'],
    [90631, 'CI BOLSA'],
    [90634, 'FINCOMUN'],
    [90638, 'NUBANK'],
    [90646, 'STP'],
    [90652, 'CREDICAPITAL'],
    [90653, 'KUSPIT'],
    [90656, 'UNAGRA'],
    [90659, 'ASP INTEGRA OPC'],
    [90661, 'KLAR'],
    [90670, 'LIBERTAD'],
    [90677, 'CAJA POP MEXICA'],
    [90680, 'CRISTOBAL COLON'],
    [90683, 'CAJA TELEFONIST'],
    [90684, 'TRANSFER'],
    [90685, 'FONDO (FIRA)'],
    [90688, 'CREDICLUB'],
    [90699, 'FONDEADORA'],
    [90703, 'TESORED'],
    [90706, 'ARCUS FI'],
    [90710, 'NVIO'],
    [90715, 'CASHI CUENTA'],
    [90720, 'MexPago'],
    [90721, 'albo'],
    [90722, 'Mercado Pago W'],
    [90723, 'Cuenca'],
    [90725, 'COOPDESARROLLO'],
    [90727, 'TRANSFER DIRECT'],
    [90728, 'SPIN BY OXXO'],
    [90729, 'Dep y Pag Dig'],
    [90730, 'Swap'],
    [90732, 'Peibo'],
    [90734, 'FINCO PAY'],
    [90738, 'FINTOC'],
    [90901, 'CLS'],
    [90902, 'INDEVAL'],
    [90903, 'CoDi Valida'],
    [91802, 'BANAMEX2'],
    [91812, 'BBVA BANCOMER2'],
    [91814, 'SANTANDER2'],
    [91821, 'HSBC2'],
    [91872, 'BANORTE2'],
    [91927, 'AZTECA2'],
    [97846, '0 PRUEBAS']
]
